import React, { useState } from "react";

import HospitalityAdmin from "./components/HospitalityAdmin";
import TeamPhotosAdmin from "./components/TeamPhotosAdmin";



const Hospitality = () => {
  // Define tabs for the Flavours admin panel
  const TABS = {
    hero: "HospitalityHero",
    teamPhotos: "TeamPhotos",
  };

  // Default to the Hero tab
  const [activeTab, setActiveTab] = useState(TABS.hero);

  // Function to switch tabs
  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="p-4 space-y-8">
      {/* Top Buttons */}
      <div className="flex flex-wrap gap-4 mb-6">
        <button
          onClick={() => handleTabChange(TABS.hero)}
          className={`px-6 py-2 rounded ${
            activeTab === TABS.hero
              ? "bg-blue-600 text-white"
              : "bg-gray-200 text-gray-700"
          }`}
        >
          Hospitality Hero
        </button>
        <button
          onClick={() => handleTabChange(TABS.teamPhotos)}
          className={`px-6 py-2 rounded ${
            activeTab === TABS.teamPhotos
              ? "bg-blue-600 text-white"
              : "bg-gray-200 text-gray-700"
          }`}
        >
          Team Photos
        </button>
      </div>

      {/* Render selected component */}
      <div className="bg-gray-50 p-4 rounded shadow">
        {activeTab === TABS.hero && <HospitalityAdmin />}
        {activeTab === TABS.teamPhotos && <TeamPhotosAdmin />}
        {/* Add other components here as needed */}
        {/* Uncomment the following lines when the components are ready */}
        {/* {activeTab === TABS.ourChef && <FlavoursOurChef />}
        {/* Uncomment the following lines when the components are ready */}
        {/* {activeTab === TABS.gallery && <FlavoursGallery />}
        {activeTab === TABS.specials && <FlavoursSpecials />} */}
      </div>
    </div>
  );
};

export default Hospitality;